import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

/*
radio button
*/

const RadioButton = ({ checked, id, label, name, onChange, value }) => (
    <div className="input-radio-sto">
        <input checked={checked} id={id} name={name} onChange={onChange} type="radio" value={value} />
        <label htmlFor={id}>
            <FormattedMessage id={label} />{' '}
        </label>
    </div>
);

RadioButton.propTypes = {
    checked: PropTypes.bool,
    id: PropTypes.string,
    name: PropTypes.string,
    onChange: PropTypes.func,
    value: PropTypes.string,
};

export default RadioButton;
